export const CHART_FONT_FAMILY = 'Open Sans, sans-serif'

export const CHART_COLORS = {
  primary: '#3AABF2',
  primaryContent: '#11174B',
  secondaryContent: '#707070',
  placeholderContent: '#B9BBC9',
  white: '#FFFFFF',
  tooltipBackground: 'rgba(17, 23, 75, 0.9)',
  gridLine: 'rgba(17, 23, 75, 0.1)'
}

export const CHART_PALETTE = [
  '#3AABF2',
  '#254291',
  '#70D6C6',
  '#2985AE',
  '#B021D9',
  '#2D65FF',
  '#47BFAD'
]

export const DEFAULT_LINE_CHART_HEIGHT = 300
export const DEFAULT_DOUGHNUT_HEIGHT = 220

export const toChartPixelHeight = (height?: string | number): number | string => {
  if (height == null || height === '') {
    return DEFAULT_LINE_CHART_HEIGHT
  }
  if (typeof height === 'number') {
    return height
  }
  const trimmed = String(height).trim()
  if (trimmed === '100%') {
    return '100%'
  }
  if (trimmed.endsWith('%')) {
    const percent = parseFloat(trimmed)
    if (!Number.isNaN(percent) && percent <= 45) {
      return DEFAULT_DOUGHNUT_HEIGHT
    }
    return DEFAULT_LINE_CHART_HEIGHT
  }
  const asNumber = Number(trimmed)
  return Number.isNaN(asNumber) ? trimmed : asNumber
}

export const toChartNumber = (value: any): number => {
  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed : 0
}

export const formatCenterLabel = (label?: string): string => {
  if (!label) return ''
  return String(label)
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<[^>]+>/g, '')
    .replace(/[ \t]+\n/g, '\n')
    .replace(/\n[ \t]+/g, '\n')
    .trim()
}
